import * as AuthActions from './auth.actions';
import { createFeatureSelector } from '@ngrx/store';
import { AuthData } from '../auth-data.model';

export interface AuthState {
    loading: boolean;
    loggedIn: boolean;
    failed: boolean;
    authData: AuthData;
    loadedAt: number;
};

const INITIAL_STATE: AuthState = {
    loading: false,
    loggedIn: false,
    failed: false,
    authData: null,
    loadedAt: null
};

export function authReducer(state = INITIAL_STATE, action: AuthActions.AuthActionsAll): AuthState {
    if (!action) return state;

    switch (action.type) {

        case AuthActions.DO_LOGIN:
        case AuthActions.DO_LOGOUT: {
            return Object.assign({}, state, {
                loading: true,
                loggedIn: false,
                failed: false,
                authData: null,
                loadedAt: null
            });
        }

        case AuthActions.DO_AUTO_LOGIN_SUCCESS:
        case AuthActions.DO_LOGIN_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                loggedIn: true,
                failed: false,
                authData: action.payload,
                loadedAt: new Date().getTime()
            });
        }

        case AuthActions.DO_LOGOUT_SUCCESS: {
            return Object.assign({}, state, INITIAL_STATE);
        }

        case AuthActions.DO_AUTO_LOGIN_FAIL:
        case AuthActions.DO_LOGIN_FAIL:
        case AuthActions.DO_LOGOUT_FAIL: {
            return Object.assign({}, INITIAL_STATE, { loading: false, failed: true,  loadedAt: new Date().getTime() });
        }
        case AuthActions.RESET_EMAIL_DRIVE: {
            const updatedAuthData = state.authData
            ? { ...state.authData, emailDrive: action.payload }
            : null;
    
        if (updatedAuthData) {
            localStorage.setItem('authData', JSON.stringify(updatedAuthData));
        }
    
        return {
            ...state,
            authData: updatedAuthData
        };
        }
        

        default: {
            return state;
        }
    }
}

export const getAuthState = createFeatureSelector<AuthState>(
    'auth'
);